export function serverUrlFor(
  params: Pick<URLSearchParams, "get">,
  where: { readonly protocol: string; readonly host: string },
): string | null {
  const requested = params.get("server");
  if (requested === "offline" || requested === "none") return null;
  if (requested !== null && requested !== "") return requested;
  const scheme = where.protocol === "https:" ? "wss:" : "ws:";
  return `${scheme}//${where.host}/ws`;
}
